export interface ESignDocument {
    eSignDocumentGuid: string;
    reminderFrequency: ESignDocumentReminderFrequency;
    productSubscriptionId: number | null;
    companySubscriptionId: number | null;
    agreementId: string;
    state: ESignDocumentState;
    eSignDocumentActivityLogs: ESignDocumentActivityLog[] | null;
    lastSentOn: Date | null;
    lastSentLocalTime: string | null;
    senderEmail: string | null;
    senderName: string | null;
    createdOn: Date | null;
    modifiedOn: Date | null;
    modifiedOnLocalTime: string | null;
}

export interface ESignDocumentActivityLog {
    eSignDocumentActivityLogId: number;
    eSignDocumentActivityLogGuid: string;
    eSignDocumentId: number;
    eventType: ESignDocumentEventType | null;
    agreementStatus: ESignDocumentStatus | null;
    customerStatus: string | null;
    cerebroStatus: string | null;
    createdOnLocalTime: string | null;
    customerEmail: string;
    contractSigner: string;
    sender: string;
    createdOn: Date | null;
    modifiedOn: Date | null;
}

export type ESignDocumentState = keyof typeof ESignDocumentStateMap;
export const ESignDocumentStateMap = {
	Authoring: 'Authoring',
	Draft: 'Draft',
	InProcess: 'In Process',
	Restart: 'Restart',
	Completed: 'Completed',
	Cancelled: 'Cancelled',
};

export type ESignDocumentReminderFrequency = keyof typeof ESignDocumentReminderFrequencyMap;
export const ESignDocumentReminderFrequencyMap = {
	None: 'None',
  DailyUntilSigned: 'Daily Until Signed',
	WeekDailyUntilSigned: 'Weekdaily Until Signed',
	EveryOtherDayUntilSigned: 'Every Other Day Until Signed',
	EveryThirdDayUntilSigned: 'Every Third Day Until Signed',
	EveryFifthDayUntilSigned: 'Every Fifth Day Until Signed',
	WeeklyUntilSigned: 'Weekly Until Signed',
	Once: 'Once'
};

export type ESignDocumentStatus = keyof typeof ESignDocumentStatusMap;
export const ESignDocumentStatusMap = {
  OutForSignature: 'Out for Signature',
  OutForDelivery: 'Out for Delivery',
  OutForAcceptance: 'Out for Acceptance',
  OutForFormFilling: 'Out for Form Filling',
  OutForApproval: 'Out for Approval',
  OutForWitnessing: 'Out for Witnessing',
  Authoring: 'Authoring',
  Cancelled: 'Cancelled',
  Signed: 'Signed',
  Approved: 'Approved',
  Delivered: 'Delivered',
  Accepted: 'Accepted',
  FormFilled: 'Form Filled',
  Expired: 'Expired',
  Archived: 'Archived',
  Prefill: 'Prefill',
  Draft: 'Draft',
  DocumentsNotYetProcessed: 'Documents Not Yet Processed',
  WaitingForFaxin: 'Waiting for Faxin',
  WaitingForVerification: 'Waiting for Verification',
  WaitingForNotarization: 'Waiting for Notarization',
};


export type ESignDocumentEventType = keyof typeof ESignDocumentEventTypeMap;
export const ESignDocumentEventTypeMap = {
  Unknown: 'Unknown',
  AgreementSignerNameChangedBySigner: 'Agreement Signer Name Changed By Signer',
  AgreementDocumentsViewed: 'Agreement Documents Viewed',
  AgreementReminderCreated: 'Agreement Reminder Created',
  AgreementReminderUpdated: 'Agreement Reminder Updated',
  AgreementStatusRequested: 'Agreement Status Requested',
  AgreementActionCompleted: 'Agreement Action Completed',
  AgreementActionDelegated: 'Agreement Action Delegated',
  AgreementActionReplacedSigner: 'Agreement Action Replaced Signer',
  AgreementActionRequested: 'Agreement Action Requested',
  AgreementAutoCancelledConversionProblem: 'Agreement Auto Cancelled Conversion Problem',
  AgreementCreated: 'Agreement Created',
  AgreementDocumentsDeleted: 'Agreement Documents Deleted',
  AgreementEmailBounced: 'Agreement Email Bounced',
  AgreementEmailViewed: 'Agreement Email Viewed',
  AgreementExpired: 'Agreement Expired',
  AgreementKbaAuthenticated: 'Agreement Kba Authenticated',
  AgreementModified: 'Agreement Modified',
  AgreementOfflineSync: 'Agreement Offline Sync',
  AgreementRecalled: 'Agreement Recalled',
  AgreementRejected: 'Agreement Rejected',
  AgreementShared: 'Agreement Shared',
  AgreementUploadedBySender: 'Agreement Uploaded By Sender',
  AgreementUserAckAgreementModified: 'Agreement User Ack Agreement Modified',
  AgreementVaulted: 'Agreement Vaulted',
  AgreementWebIdentityAuthenticated: 'Agreement Web Identity Authenticated',
  AgreementWorkflowCompleted: 'Agreement Workflow Completed',
  LibraryDocumentAutoCancelledConversionProblem: 'Library Document Auto Cancelled Conversion Problem',
  LibraryDocumentCreated: 'Library Document Created',
  LibraryDocumentModified: 'Library Document Modified',
  MegaSignCreated: 'Megasign Created',
  MegaSignRecalled: 'Megasign Recalled',
  MegaSignShared: 'Megasign Shared',
  WidgetEnabled: 'Widget Enabled',
  WidgetDisabled: 'Widget Disabled',
  WidgetCreated: 'Widget Created',
  WidgetModified: 'Widget Modified',
  WidgetShared: 'Widget Shared',
  WidgetAutoCancelledConversionProblem: 'Widget Auto Cancelled Conversion Problem',
};
